// #GR32/#GR35 — the single source of truth for "which build job_types are actual SITE
// DEPLOYS" (they produce a Cloudflare preview/production deployment) vs everything else
// (provision, seo/seo-intake, brand-extract/brand-preview, content-media, retire, and
// any agent_job:*), which must NOT drive a deploy-status chip or a "building"/"in-preview"
// reading. Imported by FleetView (status pill + Last-deploy fallback) and AdminDashboard
// (Recent-builds preview/promote columns).
//
// ⚠️ Kept in sync with migration 0026's allow-list on the latest_build_per_client view
// (SQL can't import this constant — the migration cross-references this file by comment).
// If you add a deploy-producing job_type, update BOTH here and mig 0026.
export const DEPLOY_JOB_TYPES = new Set(['build-chat', 'assembly', 'promote']);

/** Whether a build row is a real site deploy (drives the CF deploy-status affordances). */
export function isDeployBuild(b: { job_type: string }): boolean {
  return DEPLOY_JOB_TYPES.has(b.job_type);
}
